import React, { useState } from 'react'
import './ComingSoonLanding.css'

interface ComingSoonLandingProps {
  onTesterLogin: () => void
}

export default function ComingSoonLanding({ onTesterLogin }: ComingSoonLandingProps) {
  const [email, setEmail] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [message, setMessage] = useState('')
  const [isSuccess, setIsSuccess] = useState(false)

  const handleEmailSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    
    if (!email.trim()) {
      setMessage('Please enter your email address')
      setIsSuccess(false)
      return
    }

    setIsSubmitting(true)
    setMessage('')

    try {
      const response = await fetch('/api/waitlist', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email.trim() })
      })

      const data = await response.json()

      if (data.success) {
        setMessage(data.message)
        setIsSuccess(true)
        setEmail('')
      } else {
        setMessage(data.message || 'Something went wrong. Please try again.')
        setIsSuccess(false)
      }
    } catch (error) {
      setMessage('Something went wrong. Please try again.')
      setIsSuccess(false)
    } finally {
      setIsSubmitting(false)
    }
  }
  return (
    <div className="coming-soon-container">
      <div className="coming-soon-content">
        <div className="logo-section">
          <img src="/images/UKlogoblack.png" alt="Unbiased Kratom" className="main-logo" />
          <h1 className="site-title">Unbiased Kratom</h1>
          <h2 className="subtitle">The Future of Kratom Industry Standards</h2>
        </div>

        <div className="hero-section">
          <h3 className="hero-tagline">Elevating Transparency. Building Trust. Protecting Consumers.</h3>
          <p className="hero-description">
            We're building the comprehensive platform the kratom alkaloid community deserves - where honest reviews meet industry accountability, and where both vendors and consumers can connect through transparency and trust.
          </p>
        </div>

        <div className="features-section">
          <h3>What We're Creating:</h3>
          <div className="features-grid">
            <div className="feature-item">
              <span className="feature-icon">🔍</span>
              <div className="feature-content">
                <h4>Verified Review System</h4>
                <p>Trusted reviewers providing honest, detailed assessments of kratom and 7-OH products from every major vendor.</p>
              </div>
            </div>

            <div className="feature-item">
              <span className="feature-icon">🏪</span>
              <div className="feature-content">
                <h4>Comprehensive Vendor Directory</h4>
                <p>Complete listings with overall scoring, lab results, and real customer feedback to help you make informed decisions.</p>
              </div>
            </div>

            <div className="feature-item">
              <span className="feature-icon">🎓</span>
              <div className="feature-content">
                <h4>Educational Hub</h4>
                <p>In-depth guides covering everything from potentiation and dosing to tapering protocols and harm reduction resources.</p>
              </div>
            </div>

            <div className="feature-item">
              <span className="feature-icon">💬</span>
              <div className="feature-content">
                <h4>Community Platform</h4>
                <p>A safe space where vendors and customers connect, share experiences, and build relationships based on honesty and quality.</p>
              </div>
            </div>

            <div className="feature-item">
              <span className="feature-icon">🛒</span>
              <div className="feature-content">
                <h4>Quality Accessories</h4>
                <p>Precision scales, measuring tools, and storage solutions to support responsible kratom use.</p>
              </div>
            </div>

            <div className="feature-item">
              <span className="feature-icon">📊</span>
              <div className="feature-content">
                <h4>Taper Tracker Pro</h4>
                <p>Advanced dose tracking and tapering platform to help users monitor their intake, create personalized taper schedules, and achieve their wellness goals through data-driven insights.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mission-section">
          <h3>Our Mission</h3>
          <p>
            The kratom industry needs cleaning up. Users shouldn't worry about getting ripped off or unknowingly receiving products with harmful solvents. We're creating a new standard that holds vendors accountable to higher levels of transparency and quality.
          </p>
          <p>
            We're not just another review site - we're building the future of how the kratom community researches, purchases, and uses these products responsibly.
          </p>
        </div>

        <div className="launch-section">
          <h3>Coming 2025</h3>
          <p>Join the waitlist to be the first to know when we launch</p>
          <form onSubmit={handleEmailSubmit} className="email-signup">
            <input 
              type="email" 
              placeholder="Enter your email address" 
              className="email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isSubmitting}
            />
            <button 
              type="submit" 
              className="signup-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Joining...' : 'Join Waitlist'}
            </button>
          </form>
          {message && (
            <div className={`signup-message ${isSuccess ? 'success' : 'error'}`}>
              {message}
            </div>
          )}
        </div>

        <div className="tester-section">
          <button className="tester-login-button" onClick={onTesterLogin}>
            ARE YOU A TESTER? CLICK HERE TO LOG IN
          </button>
        </div>

        <div className="footer-section">
          <p className="footer-text">UnbiasedKratom.com - Where integrity meets information</p>
          <div className="footer-links">
            <a href="/privacy-policy" className="footer-link">Privacy Policy</a>
            <span className="footer-separator">•</span>
            <a href="/terms-of-service" className="footer-link">Terms of Service</a>
          </div>
        </div>
      </div>
    </div>
  )
}